import { cardRewardFrameClass } from "./cardFrame.js";
import type { CardDefinition } from "../domain/types/index.js";

export type PlayRarity = "small" | "medium" | "large";

export function playRarityFromFrame(frame: ReturnType<typeof cardRewardFrameClass>): PlayRarity {
  if (frame === "is-rainbow-frame") return "large";
  if (frame === "is-hologram-frame") return "medium";
  return "small";
}

export function playRarityOf(definition: CardDefinition): PlayRarity {
  return playRarityFromFrame(cardRewardFrameClass(definition));
}

export function playSlamPalette(rarity: PlayRarity): readonly string[] {
  if (rarity === "small") return ["#ffffff"];
  if (rarity === "medium") return ["#9defff", "#3b9fda", "#c8b8ff"];
  return ["#ff6f7f", "#ffe86a", "#63d88c", "#59c8ff", "#8e7dff", "#ec74d8"];
}

export function playFlashColor(rarity: PlayRarity): string {
  if (rarity === "small") return "#ffffff";
  if (rarity === "medium") return "#3b9fda";
  return "#ff6f7f";
}
